var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isCard())?_c('BannerSlider',{attrs:{"config":_vm.config,"container":_vm.container,"isCard":_vm.isCard(),"customProposals":_vm.customProposals}}):_c('ProductSlider',{attrs:{"config":_vm.config,"container":_vm.container,"categoryBlockName":'CatalogSlider'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }